import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeildErrorComponent } from './feild-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';



@NgModule({
  declarations: [
    FeildErrorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule
  ],
  exports:[
    FeildErrorComponent,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FieldErrorModule { }
